import { Portal } from '@portals/ui-kit';
import classNames from 'classnames/bind';
import { ECountry } from '@portals/help-center-core';
import { useTranslations } from 'next-intl';
import {
  COOKIE_STORAGE_PREFIX,
  WARNING_COOKIES_PORTAL_PREFIX,
} from '@/layouts/app-layout/_constants';
import { useClientSearchParams } from '@/_hooks/use-client-search-params';
import { WarningCookiesBanner } from './_components/warning-cookies-banner';
import style from './index.module.scss';

const cn = classNames.bind(style);
const BLOCK_NAME = 'Warning-cookie-banner-wrapper';

type TProps = {
  country: ECountry;
};

export const WarningCookieBannerWrapper = ({ country }: TProps) => {
  const translations = useTranslations('cookie-banner');
  const { isSideMode } = useClientSearchParams();

  const buttonText = translations('buttonAgreedText');
  const bannerText = translations('cookiesBannerText');

  const isCountryAvailable = country === ECountry.RUSSIA;

  if (!isCountryAvailable || isSideMode) return null;

  return (
    <Portal prefix={WARNING_COOKIES_PORTAL_PREFIX} zIndex={99}>
      <div className={cn(BLOCK_NAME)}>
        <WarningCookiesBanner
          buttonAgreedText={buttonText}
          cookieStoragePrefix={COOKIE_STORAGE_PREFIX}
          text={bannerText}
        />
      </div>
    </Portal>
  );
};
